import React from 'react';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import useComponentState from '../../utils/useComponentState';
import styles from './Search.module.scss';

const Search = ({
  placeholder,
  onBtnPress,
  onClearPress,
  max,
  onChangeKey,
  value,
  onChange,
  searchInput,
  handleValueFromParent,
  validation,
  searchOnChange,
  searchKey,
}) => {
  const [state, setState] = useComponentState({
    input: '',
    isApiCalled: searchKey ? true : false,
  });

  const handleOnSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (handleValueFromParent) {
      if (!form.checkValidity()) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (!state.isApiCalled) {
        setState({
          isApiCalled: true,
        });
        onBtnPress(value);
      } else {
        setState({
          isApiCalled: false,
        });
        onChange('');
        onClearPress();
      }
    } else {
      if (!form.checkValidity()) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (!state.isApiCalled) {
        setState({
          isApiCalled: true,
        });
        onBtnPress(state.input);
      } else {
        setState({
          isApiCalled: false,
          input: '',
        });
        onClearPress();
      }
    }
  };

  const handleInputOnChange = (event) => {
    if (handleValueFromParent) {
      setState({
        isApiCalled: false,
      });
      onChange(event.target.value);
      onChangeKey && onChangeKey(event.target.value);
    } else {
      setState({
        input: event.target.value,
        isApiCalled: false,
      });
      onChangeKey && onChangeKey(event.target.value);
    }
  };

  const isClearMode = state.isApiCalled && value !== '';

  return (
    <div className={styles.root}>
      <form noValidate onSubmit={handleOnSubmit}>
        <div className={styles.field}>
          <FontAwesomeIcon icon={faSearch} className={styles.icon} />
          <input
            type='text'
            className={styles.input}
            placeholder={placeholder}
            aria-label={placeholder}
            value={handleValueFromParent ? value : state.input}
            onChange={handleInputOnChange}
            required
            maxLength={max}
          />
          <button
            type='submit'
            className={`${styles.button} ${isClearMode ? styles.buttonClear : ''}`}
            aria-label={isClearMode ? 'Clear search' : 'Search'}
          >
            {isClearMode ? 'Clear' : 'Search'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Search;
